import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { AdmissionPacketWorkspace } from "@/components/app/admission-packet/packet/workspace";

export const Route = createFileRoute(
  "/_authenticated/_crm/crm/leads/$leadId_/admission-packets/$packetId",
)({
  component: LeadAdmissionPacketWorkspace,
});

/** An admission packet begun during the enquiry, before there is a chart to hang it on. */
function LeadAdmissionPacketWorkspace() {
  const { leadId, packetId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <AdmissionPacketWorkspace
      key={packetId}
      packetId={packetId}
      onOpenPacket={(next) =>
        navigate({
          to: "/crm/leads/$leadId/admission-packets/$packetId",
          params: { leadId, packetId: next },
        })
      }
      back={
        <Link to="/crm/leads/$leadId" params={{ leadId }} className="hover:underline">
          Back to the enquiry
        </Link>
      }
    />
  );
}
